export default __webpack_public_path__ + "static/media/The-Best-80s-Music-Background-750x490.4fe6c76c.jpeg";